import { SeeqNames } from '@/main/app.constants.seeqnames';

export const getLockingChannel = (workbookId: string) => [SeeqNames.Channels.LockingChannel, workbookId];
